import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import QueryString from "query-string";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonText,
} from "@ionic/react";

import ResendActivationForm from "./ResendActivationForm";
import { resendActivationEmail } from "../../modules";
import { AppStateDisplay, clearAll } from "../../../common";
import strings from "../../../../res/strings";

import styled from "styled-components";
const Panel = styled.div`
  background: rgba(255, 255, 255, 0.15);
  height: 100vh;
`;

let ResendActivationPanel = (props) => {
  const handleResendActivation = (values) => {
    props.resendActivationEmail({
      values,
      successState: {
        notificationType: "banner",
        title: strings.lib_common_state_success,
        message:
          strings.lib_authentication_state_success_resend_activation_email,
        redirects: [
          {
            label: strings.lib_authentication_redirect_login_back,
            onClick: () => {
              props.clearAll();
              props.setRightPanel("LOGIN");
            },
          },
        ],
      },
      errorState: (error, values) => ({
        ...error,
        notificationType: "banner",
        title: strings.lib_common_state_error_title,
        redirects: [
          {
            label: strings.lib_authentication_redirect_login_back,
            onClick: () => {
              props.clearAll();
              props.setRightPanel("LOGIN");
            },
          },
        ],
      }),
    });
  };

  return (
    <Panel>
      <AppStateDisplay parsedQuery={props.parsedQuery}>
        {!props.success && !props.error && (
          <div>
            <IonText color="primary">
              <ResendActivationForm
                onSubmit={handleResendActivation}
                setRightPanel={props.setRightPanel}
              />
            </IonText>
          </div>
        )}
      </AppStateDisplay>
    </Panel>
  );
};

const mapStateToProps = (state) => ({
  success: state.lib_application.success,
  error: state.lib_application.error,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      resendActivationEmail,
      clearAll,
    },
    dispatch
  );
ResendActivationPanel = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResendActivationPanel);

export { ResendActivationPanel };

const ResendActivationPage = (props) => {
  const parsedQuery = QueryString.parse(props.location.search);

  useEffect(() => {
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>
            {strings.lib_authentication_title_resend_activation}
          </IonTitle>
        </IonToolbar>
        <IonContent fullscreen>
          <ResendActivationPanel
            parsedQuery={parsedQuery}
            setRightPanel={props.setRightPanel}
          />
        </IonContent>
      </IonHeader>
    </IonPage>
  );
};

export default ResendActivationPage;
